<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="4">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <b-form @submit="onSubmit">
                  <h1>Login</h1>
                  <p class="text-muted">Sign In to your account</p>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text><i class="icon-user"></i></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input type="text"
                                  v-model="username"
                                  class="form-control"
                                  placeholder="Username"
                                  autocomplete="username email"/>
                  </b-input-group>
                  <b-input-group class="mb-4">
                    <b-input-group-prepend>
                      <b-input-group-text><i class="icon-lock"></i></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input type="password"
                                  v-model="password"
                                  class="form-control"
                                  placeholder="Password"
                                  autocomplete="current-password"/>
                  </b-input-group>
                  <b-row>
                    <b-col cols="6">
                      <b-button variant="primary" class="px-4" type="submit">Login</b-button>
                    </b-col>
                    <b-col cols="6" class="text-right">
                      <!--<b-button variant="link" class="px-0">Forgot password?</b-button>-->
                    </b-col>
                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoginPage',
  data () {
    return {
      username: '',
      password: ''
    }
  },
  created () {
    if (this.$loading.isShow === true) {
      this.$loading.hide()
    }
    this.$store.dispatch('resetAuth')
  },
  methods: {
    onSubmit (event) {
      event.preventDefault()

      this.$loading.show(true)
      this.$store.dispatch('login', {
        username: this.username,
        password: this.password
      }, {root: true}).then(response => {
        const {data} = response
        if (data && data.status === 200) {
          this.$router.push({name: 'Home'})
        } else {
          this.$toastr.error(data.message)
        }
        this.$loading.hide()
      }, (error) => {
        this.$loading.hide()
        if (error.response) {
          this.$toastr.error(error.response.data.message)
        } else {
          this.$toastr.error(error.message)
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/LoginPage.vue